import * as React from 'react';
import { NotificationApiResponse, AppNotification } from './types';
import CampaignIcon from '@mui/icons-material/Campaign';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

/**
 * APIレスポンスをコンポーネント用の通知データに変換します。
 * @param apiResponse - APIから取得した単一の通知データ
 * @returns コンポーネントで使える形式の通知データ
 */
export const mapToAppNotification = (apiResponse: NotificationApiResponse): AppNotification => {
  const actions: AppNotification['actions'] = [];

  // message内のURLを検出し、アクションとして追加
  if (apiResponse.link) {
    actions.push({
      label: 'リンクを開く',
      onClick: () => window.open(apiResponse.link!, '_blank', 'noopener,noreferrer')
    });
  }

  return {
    id: apiResponse.id,
    icon: apiResponse.type == 'important' ? React.createElement(PriorityHighIcon) : React.createElement(CampaignIcon),
    date: new Date(apiResponse.publishedAt),
    summary: apiResponse.title,
    details: apiResponse.message,
    isRead: apiResponse.readAt !== null,
    actions: actions.length > 0 ? actions : undefined
  };
};
